import { Button } from '@mui/material';
import { useEffect, useState } from 'react';

import { BreedDialog } from 'entities/breed';

import { Breed } from 'shared/api';

type Props = {
  disabled?: boolean;
  onSubmit: (data: Partial<Breed>) => void;
  isSuccess: boolean;
  isLoading: boolean;
};

export const CreateBreed = ({ disabled = false, onSubmit, isSuccess, isLoading }: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (isSuccess) setIsOpen(false);
  }, [isSuccess]);

  return (
    <>
      <Button variant="contained" onClick={() => setIsOpen(true)} sx={{ alignSelf: 'end' }} disabled={disabled}>
        Add breed
      </Button>
      <BreedDialog
        title="Add breed"
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onSubmit={onSubmit}
        isLoading={isLoading}
      />
    </>
  );
};
